// src/styles/colors.js
export const colors = {
  primary: "#DBB07A",     // Golden Beige
  secondary: "#0F3B2E",   // Dark Green
  background: "#FFFFFF",  // White
  textDark: "#111111",    // Off-black for premium legibility
  textLight: "#FFFFFF",
  mutedGreen: "rgba(15, 59, 46, 0.05)",
  borderGold: "rgba(219, 176, 122, 0.3)"
};